/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "mode", "onModeChange", "eventKey", "fetchImageFileInfo"];
import { useState, useEffect, useCallback, useRef } from 'react';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import withPopoverModeState from './withPopoverModeState';
import TinyMcePopover from './TinyMcePopover';
import { getImageAttributes } from '../hsimage/handlers';
import ImagePopover from './ImagePopover';
import { jsx as _jsx } from "react/jsx-runtime";
function ImagePopoverManager(props) {
  const {
      editor,
      mode,
      onModeChange,
      eventKey,
      fetchImageFileInfo
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [target, setTarget] = useState(null);
  const [refreshKey, setRefreshKey] = useState(1);
  const [imageAttrs, setImageAttrs] = useState({});
  const [imageFileInfo, setImageFileInfo] = useState({});
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
      setImageAttrs({});
    }
  }, []);
  const handleModeChange = useCallback(nextMode => {
    if (nextMode === PopoverBodyMode.EDIT) {
      setImageAttrs(getImageAttributes(editor, lastTarget.current));
    }
    onModeChange(nextMode);
  }, [editor, onModeChange]);
  useEffect(() => {
    const handleInsertLink = () => {
      handleModeChange(PopoverBodyMode.EDIT);
    };
    editor.on('InsertLinkOnImage', handleInsertLink);
    return () => editor.off('InsertLinkOnImage', handleInsertLink);
  }, [editor, handleModeChange]);
  useEffect(() => {
    const handleHsNodeChange = ({
      element
    }) => {
      if (!element) {
        handleRemove();
        return;
      }
      if (element !== lastTarget.current) {
        fetchImageFileInfo(element).then(setImageFileInfo);
        onModeChange(PopoverBodyMode.PREVIEW);
        setTarget(element);
        setImageAttrs({
          altText: editor.dom.getAttrib(element, 'alt') || '',
          loadingValue: editor.dom.getAttrib(element, 'loading', 'default')
        });
      } else {
        // We need this dummy prop for ImagePopoverBodyLite to force a
        // re-render so tether updates after alignment changes (since that's
        // done via the toolbar and thus no alignment prop gets threaded)
        setRefreshKey(element.outerHTML);
      }
    };
    editor.on(`hsNodeChange:${eventKey}`, handleHsNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleHsNodeChange);
  }, [editor, handleRemove, onModeChange, eventKey, fetchImageFileInfo]);
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    "data-test-id": "image-popover-manager",
    editor: editor,
    open: !!target,
    target: target,
    onRemove: handleRemove,
    arrowSize: "medium",
    placement: mode === PopoverBodyMode.EDIT ? 'right' : 'bottom',
    renderContent: renderProps => /*#__PURE__*/_jsx(ImagePopover, Object.assign({}, rest, imageAttrs, {
      imageFileInfo: imageFileInfo,
      refreshKey: refreshKey,
      editor: editor,
      target: target,
      mode: mode,
      onModeChange: handleModeChange,
      trackLinkUsageProps: {
        isImage: true
      }
    }, renderProps))
  });
}
export default withPopoverModeState(ImagePopoverManager);